/** Matches a path segment that names a PDF file. */
const PDF_FILE_NAME = /\.pdf$/i;

/**
 * Resolves the name a stored document is shown under: its stored name, or else the file name its
 * address ends in.
 *
 * Lexplus 1.0 stores no name for an uploaded document, only its address, and that address ends in
 * the file name the upload had — «…/Upload/FAQ/9_de_Wie_fuelle_ich….pdf». An address that does not
 * end in a PDF file name, such as the stable `…/faq/:id/pdf/:sprache` address of a 2.0 upload,
 * yields no name; those uploads store one.
 *
 * @param {string | null | undefined} dateiName - The stored name, empty where none was stored
 * @param {string | null | undefined} dateiUrl - The document's address
 * @returns {string | undefined} The name to show, or `undefined` where neither carries one
 */
export function resolveDocumentName(dateiName: string | null | undefined, dateiUrl: string | null | undefined): string | undefined {
  const storedName = dateiName?.trim();
  if (storedName) {
    return storedName;
  }

  const lastSegment = dateiUrl?.trim().split(/[?#]/)[0].split('/').pop();
  if (!lastSegment || !PDF_FILE_NAME.test(lastSegment)) {
    return undefined;
  }

  try {
    return decodeURIComponent(lastSegment);
  } catch {
    // A stray «%» that is no escape sequence; the segment as stored is still the best name there is.
    return lastSegment;
  }
}
